document.addEventListener("DOMContentLoaded", function () {
  const links = document.querySelectorAll("a[href^=http]");
  for (let i = 0; i < links.length; ++i) {
    const link = links[i];

    // 子に img 要素を持つ場合はアイコンを表示しない
    const is_images = link.getElementsByTagName("img");
    if (is_images.length > 0) {
      continue;
    }
    //内部リンク時の処理
    const is_home_link = link.getAttribute("href");
    const reg = new RegExp("^(https?:)?//" + document.domain);
    if (is_home_link.match(reg) || is_home_link.charAt(0) === "/") {
      continue;
    }

    // アイコン用要素の作成
    var iconElement = document.createElement("span"); // p要素作成
    iconElement.setAttribute("class", "gdr_external_link"); // p要素にidを設定

    // 要素を追加して外部リンクアイコンを表示
    link.appendChild(iconElement);
  }
});
